import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryASPUActions } from "../../../../store/external/inventory/aspu.reducer";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import '../../../common/report/reports/Invoice/invoice-table.component.css';
import ButtonIcon from "../../../button";
import { CustomColumns } from "../../../common/modal-popover/custom-columns";
import Filter from "../../../common/filter/filter.component";
import '../../inventory/inventory-component.css'
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { TRANSLATIONS as translation } from "../../../../utils/constant.utils";
class InventoryASPU extends Component {
    constructor(props) {
        super(props);
        this.DisplaySearhBox = this.DisplaySearhBox.bind(this)
        this.openLineItem = this.openLineItem.bind(this)

        this.state = {
            modifyColTitle: '',
            extractInventoryTitle: '',
            searchTitle: '',            
            tableSelected: false,
            closeForm: false,
            rowId: "0",
            pageNumber: 0,
            viewType: 'list',
            displaySearch: false,
            selectedIndex: 0,
            dataSelected: [],
            listTabInfo: {
                Tab: [
                    {
                        "id": "0",
                        "label": "Subscription Details"
                    },
                    {
                        "id": "1",
                        "label": "Usage Spend"
                    }
                ]
            },
            historyList: []
        }
    }

    componentDidMount() {
        this.props.getInventoryASPU();
    }
    componentWillUnmount(){
        this.props.setResetSearch();
        this.props.resetInventoryASPUData();
    }
    DisplaySearhBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    openLineItem(data) {
        this.setState({ tableSelected: data })
    }

    CloseForm(data) {
        this.setState({ tableSelected: data })
    }

    getDataSelected(data) {
        this.setState({ selectedIndex: data })

    }

    resizePage = (value) => {
        const { getInventoryASPU, resizeInventoryASPUPage } = this.props;
        resizeInventoryASPUPage(value);
        getInventoryASPU();
    }

    toLocaleLanguage = (key) => {
            const { locale } = this.props;
            if (locale === null || locale === '' || locale === undefined)
                return translation[translation['defaultLocaleLanguage']][key];
    
            return translation[locale][key];
    }

    onClickExtract = (e) => {
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            this.props.extractInventoryASPU();
        }
    };

    loading = () => {
        return (
            <NoSubscription />
        );
    }

    applyFilter = (isApply) => {
        const { getInventoryASPU, applyInventoryASPUFilter } = this.props;
        applyInventoryASPUFilter(isApply);
        isApply && getInventoryASPU(0);
    }
export_alert_message
    render() {

        const { inventoryASPU, getInventoryASPU, sortInventoryASPUItems, setInventoryASPUColSearchStr, addInventoryASPUFilter, removeInventoryASPUFilter, saveInventoryASPUCustomCols } = this.props;
        const { Selected, Available, Default } = this.props.inventoryASPU.inventoryASPUItems.Columns;
        let isExtractNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASPURE, ACCESS_MODULE.InventoryASPURW])
        let isFilterNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASPUR, ACCESS_MODULE.InventoryASPURE, ACCESS_MODULE.InventoryASPURW])
        let isSearchNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASPUR, ACCESS_MODULE.InventoryASPURE, ACCESS_MODULE.InventoryASPURW])
        let isCustomizedNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASPUR, ACCESS_MODULE.InventoryASPURE, ACCESS_MODULE.InventoryASPURW])
        let isShowTableNotAllowed = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryASPUR, ACCESS_MODULE.InventoryASPURE, ACCESS_MODULE.InventoryASPURW])
        return (
            <div className="invoice-wrapper-container inventory-report-component" >
                <RequestHeaders headerTitle="aspu" />
                <div className="request-table data-table fit-width">
                    {
                        !isFilterNotAllowed && <Filter data={inventoryASPU.inventoryASPUItems.TableFilterData} addAction={addInventoryASPUFilter} removeAction={removeInventoryASPUFilter} applyAction={this.applyFilter} />
                    }
                    {!isFilterNotAllowed && <div className="horizontal-separator"/> }
                    
                    <div className="container-filter-button">
                        {!isSearchNotAllowed && <ButtonIcon onClick={this.DisplaySearhBox} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search" />}
                        {!isCustomizedNotAllowed && <CustomColumns defaultList={Default} firstList={Available} secondList={Selected} saveAction={saveInventoryASPUCustomCols} />}
                        {!isExtractNotAllowed && <ButtonIcon onClick={(e) => this.onClickExtract(e)} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Extract List" />}
                    </div>
                    {
                        this.props.inventoryASPU.isInventoryASPULoaded ?                           
                            !isShowTableNotAllowed && <TablePagination
                                key={TABLE_PAGINATION_KEY.inventoryASPU}  
                                classNameWrapper="overflow-auto" 
                                columns={inventoryASPU.inventoryASPUItems.Headers}
                                pageList={inventoryASPU.inventoryASPUItems.Data}
                                pages={inventoryASPU.inventoryASPUItems.Pagination}
                                rowClickAction={() => { }}
                                paginationAction={getInventoryASPU}
                                onColumnClick={sortInventoryASPUItems}
                                onColumnSearch={() => { getInventoryASPU(0) }}
                                onColumnSearchChange={setInventoryASPUColSearchStr}
                                isColSearchShow={this.state.displaySearch}
                                resizePage={this.resizePage}
                                totalPage={inventoryASPU.inventoryASPUItems.Pagination.TotalEntries}
                            />
                            : this.loading()
                    }

                </div>
            </div>
        )
    }
}

export default connect(
    state => {
        const { inventoryASPU, translation } = state;

        return {
            inventoryASPU,
            ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryASPUActions),
        dispatch
    )
)(InventoryASPU);
